import React from "react";
import type { IconProps } from "types";

const UploadIdle = ({ color = "3C78F0" }: IconProps) => (
  <svg width="57" height="53" viewBox="0 0 57 53" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="14" cy="14" r="14" fill={color} fillOpacity="0.1" />
    <circle cx="52.5" cy="47.5" r="4.5" fill={color} fillOpacity="0.1" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.75 10.5C31.2844 10.4996 32.8026 10.8131 34.2112 11.4213C35.6199 12.0295 36.8892 12.9195 37.9411 14.0365C38.993 15.1535 39.8053 16.4739 40.3279 17.9166C40.8505 19.3592 41.0724 20.8934 40.98 22.425H41L40.9975 25.4925C43.5631 25.4918 46.0309 26.4773 47.8903 28.245C49.7497 30.0128 50.8586 32.4276 50.9875 34.99L51 35.49C50.9981 38.0543 50.0111 40.5199 48.2431 42.3772C46.4751 44.2346 44.0611 45.3418 41.5 45.47L41 45.4825H40.9975L41 45.5H28.4975V35.6925H34.6575L26 25.5075L17.365 35.695H23.5L23.4975 45.5H11C8.3477 45.4934 5.80611 44.436 3.93182 42.5593C2.05753 40.6827 1.0033 38.1398 1 35.4875C1.00045 33.1838 1.7963 30.9508 3.25303 29.1661C4.70977 27.3814 6.73803 26.1544 8.995 25.6925C8.44002 24.2426 8.34865 22.6562 8.73349 21.1522C9.11834 19.6482 9.96044 18.3006 11.1436 17.2955C12.3268 16.2904 13.7927 15.6772 15.3392 15.5405C16.8856 15.4038 18.4364 15.7504 19.7775 16.5325C20.73 14.7118 22.1631 13.1869 23.9212 12.1234C25.6793 11.0599 27.6952 10.4984 29.75 10.5Z"
      fill={color}
    />
  </svg>
);

export default React.memo(UploadIdle);
